import styled from "styled-components";
import { MediaQuery } from "ui-components";

// Wrapper for App header
const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  background: #fff;
  box-shadow: ${props => props.theme.shadow};
`;

// App header content (inside ".container")
const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  height: ${props => props.theme.header.height};
  padding: 0 15px;

  /* Remove header padding on larger screens */
  ${MediaQuery.largeUp`padding: 0;`}
`;

// Header logo image
const HeaderLogo = styled.img`
  display: flex;
  margin-right: 10px;
`;

// Header menu wrapper
const HeaderMenu = styled.div`
  display: flex;
  flex-grow: 1;

  /* Right-align the last menu item (account link) */
  > div:last-of-type { margin: 0 0 0 auto; }
`;

const HeaderMenuItem = styled.div`
  margin: 0 15px;
  /* TODO: Create a font extender (ui-components -> issue 29)*/
  font-size: ${({ theme }) => theme.fonts.sizes.Text5};
  font-family: ${({ theme }) => theme.fonts.family.bookText};
  font-weight: ${({ theme }) => theme.fonts.weight.bookText};
`;

export { HeaderWrapper, HeaderContent, HeaderLogo, HeaderMenu, HeaderMenuItem };



// WEBPACK FOOTER //
// ./src/common/components/AppHeader/styled.js